import { useState } from "react";
import { Box, Typography, Container, DialogContent } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { DeleteButton } from "../utils";
import { useDeleteProjectMutation } from "@/features/bughurd/api";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { hexToRgba } from "@/Components/helpers/util";
import ModalBasic from "@/Components/Common/ModalBasic";
import { useTranslation } from "react-i18next";

const AdvanceTab = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation(["bugherd"]);

  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [deleteProject, { isLoading }] = useDeleteProjectMutation();

  const handleDelete = async () => {
    if (!id) return;
    try {
      await deleteProject(id)
        .unwrap()
        .then((res) => {
          if (res?.data?.decryptedData) {
            setIsDeleteOpen(false);
            navigate(`/defect-tracker/projects`);
            toast.success(t("Project deleted successfully"));
          }
        })
        .catch((err) => {
          toast.error(err?.message || t("Failed to delete project"));
        });
    } catch (error) {
      toast.error(t("Failed to delete project"));
    }
  };

  return (
    <Container
      // maxWidth="md"
      sx={{
        borderRadius: 2,
        p: 3,
        background: (theme) => hexToRgba(theme.palette.primary.main, 0.1),
      }}
    >
      <Box>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 600,
            mb: 3,
          }}
        >
          {t("Delete Project")}
        </Typography>

        <Typography
          sx={{
            mb: 1,
            color: "#666",
            fontWeight: 600,
          }}
        >
          {t("Your project is active.")}
        </Typography>

        <Typography
          variant="body1"
          color="#666"
          sx={{
            mb: 3,
            // maxWidth: "800px",
          }}
        >
          {t(
            "Here you can update your project settings. Please make sure you want to delete your project as you won't be able to retrieve it when it's gone.",
          )}
        </Typography>

        <DeleteButton
          variant="outlined"
          startIcon={<DeleteOutlineIcon />}
          onClick={() => {
            setIsDeleteOpen(true);
          }}
        >
          {t("Delete Project")}
        </DeleteButton>
      </Box>
      {isDeleteOpen && (
        <ModalBasic
          id={`project-delete-modal-22`}
          open={isDeleteOpen}
          setOpen={setIsDeleteOpen}
          title={t("Delete Project")}
          onSave={handleDelete}
          titleSave={t("Confirm")}
          loading={isLoading}
          styleProp={{}}
          willUnMount={() => setIsDeleteOpen(false)}
        >
          <DialogContent>
            {t("Are you sure you want to delete this project?")}
          </DialogContent>
        </ModalBasic>
      )}
    </Container>
  );
};

export default AdvanceTab;
